module.exports = "<div class=\"hit\" id=\"hit-{{objectID}}\">\n  <div class=\"hit-picture\">\n    <img src=\"{{image}}\">\n  </div>\n  <div class=\"hit-content\">\n    <div>\n      <span>{{{_highlightResult.name.value}}}</span>\n      <span>{{price_formatted}}</span>\n      <span>{{rating}} stars</span>\n    </div>\n    <div class=\"hit-type\">\n      {{{_highlightResult.type.value}}}\n    </div>\n    <div class=\"hit-description\">\n      {{{_highlightResult.description.value}}}\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./storybook/app/utils/item.html
// module id = 694
// module chunks = 0